import React from "react";
import PaymentCheckout from "./PaymentCheckout";

function App() {
  return (
    <div>
      <PaymentCheckout />
    </div>
  );
}

export default App;
